import { Layout } from "providers/Layout";
import PageTitle from "shared/components/PageTitle";

export const NotFoundView = () => {
  return (
    <Layout>
      <PageTitle>Not found</PageTitle>
    </Layout>
  );
};
